
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iot",
      function () {
        return require("private-next-pages/iot.js");
      }
    ]);
  